import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/projektgalleri/GalleryClientPage.tsx");
